import { DropdownOption } from "../../components/inputs/dropdown/DropdownOption";

interface Entity {
    id: string | number;
}

interface NamedEntity {
    id: string | number;
    name: string;
}

interface TitledEntity {
    id: string | number;
    title: string;
}

export const mapToDropdownOption = <T extends Entity | NamedEntity | TitledEntity>(
    value: T,
    getText?: (value: T) => string
): DropdownOption => {
    if (getText) {
        return {
            key: String(value.id),
            text: getText(value)
        };
    }

    if (isNamedEntity(value)) {
        return {
            key: String(value.id),
            text: value.name
        };
    }

    if (isTitledEntity(value)) {
        return {
            key: String(value.id),
            text: value.title
        };
    }

    throw new Error("Value cannot be mapped to DropdownOption.");
};

const isNamedEntity = (value: unknown): value is NamedEntity => {
    return typeof value === "object" && value !== null && "id" in value && "name" in value;
};

const isTitledEntity = (value: unknown): value is TitledEntity => {
    return typeof value === "object" && value !== null && "id" in value && "title" in value;
};
